<div class="profile-dashboard-container py-4">
  <div class="container">

    <!-- User Banner Header -->
    <div
      class="user-profile-card p-4 mb-4 bg-white rounded-4 shadow-sm border d-flex flex-wrap align-items-center justify-content-between gap-3">
      <div class="d-flex align-items-center">
        <div class="user-avatar-wrapper me-3 position-relative" style="margin-right: 5%;">
          <div
            class="header-avatar-circle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
            style="width: 72px; height: 72px; font-size: 1.75rem; font-weight: 700;">
            <span>{{ userInitials }}</span>
          </div>
          <span
            class="online-indicator bg-success position-absolute bottom-0 end-0 p-1 border border-2 border-white rounded-circle"></span>
        </div>
        <div>
          <h2 class="h4 font-weight-bold mb-2 text-dark">
            {{ userName }}
          </h2>
          <div class="text-muted small d-flex flex-column gap-1">
            <div class="d-flex align-items-center">
              <i class="fas fa-envelope text-primary me-2"></i>
              <span>{{ userEmail }}</span>
            </div>
            <div class="d-flex align-items-center">
              <i class="fas fa-map-marker-alt text-primary me-2"></i>
              <span>{{ userLocation }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Navigation Tabs -->
    <ul class="nav nav-pills profile-tabs mb-4 bg-white p-2 rounded-3 border shadow-sm gap-2">
      <li class="nav-item">
        <a class="nav-link font-weight-bold py-2 px-3 rounded-3 cursor-pointer" [class.active]="activeTab === 'account'"
          (click)="setTab('account')">
          <i class="fas fa-user-cog me-2"></i> Datos Personales
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link font-weight-bold py-2 px-3 rounded-3 cursor-pointer" [class.active]="activeTab === 'orders'"
          (click)="setTab('orders')">
          <i class="fas fa-box-open me-2"></i> Mis Pedidos <span class="badge bg-primary text-white ms-1">{{
            orders.length }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link font-weight-bold py-2 px-3 rounded-3 cursor-pointer"
          [class.active]="activeTab === 'addresses'" (click)="setTab('addresses')">
          <i class="fas fa-map-marked-alt me-2"></i> Direcciones Guardadas
        </a>
      </li>
    </ul>

    <!-- Tab 1: Orders -->
    <div *ngIf="activeTab === 'orders'" class="tab-content-orders">

      <!-- Si hay pedidos reales -->
      <div *ngIf="orders.length > 0" class="card shadow-sm border rounded-4 overflow-hidden">
        <div class="card-header bg-white font-weight-bold py-3 border-bottom">
          <i class="fas fa-history text-primary me-2"></i> Historial de Pedidos Realizados
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover mb-0 align-middle">
              <thead class="table-light">
                <tr>
                  <th>ID Pedido / Guía</th>
                  <th>Fecha</th>
                  <th>Método de Pago</th>
                  <th>Estado</th>
                  <th class="text-end">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of orders">
                  <td class="font-weight-bold text-primary">#{{ (order.id || order.idPaymentMP || order.cartId)?.slice(-8) }}</td>
                  <td class="small">{{ (order.createDate || order.createdAt || order.date) ? ((order.createDate || order.createdAt || order.date) | date:'mediumDate') : 'Reciente' }}</td>
                  <td><span class="badge bg-light text-dark border">{{ order.paymentType || 'MercadoPago / Online' }}</span></td>
                  <td>
                    <span class="badge" [class.bg-success]="order.statusMP === 'approved' || order.paymentStatus === 'paid' || order.status === 'Confirmado'"
                      [class.bg-warning]="order.statusMP === 'pending' || order.paymentStatus === 'pending'"
                      [class.bg-danger]="order.statusMP === 'rejected' || order.paymentStatus === 'failed'">
                      <i class="fas fa-check-circle me-1" *ngIf="order.statusMP === 'approved' || order.paymentStatus === 'paid'"></i>
                      {{ (order.statusMP || order.paymentStatus || order.status || 'Aprobado') | uppercase }}
                    </span>
                  </td>
                  <td class="font-weight-bold text-end">${{ (order.totalAmount || order.total || order.amount || 0) | number }} COP</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Estado vacío si no hay pedidos -->
      <div *ngIf="orders.length === 0" class="card p-5 text-center border-0 shadow-sm rounded-4 bg-white">
        <div class="mb-3">
          <div
            class="empty-icon-circle mx-auto bg-light text-primary rounded-circle d-flex align-items-center justify-content-center"
            style="width: 80px; height: 80px; font-size: 2.25rem;">
            <i class="fas fa-box-open"></i>
          </div>
        </div>
        <h4 class="fw-bold text-dark mb-2">Aún no tienes pedidos registrados</h4>
        <p class="text-muted max-w-md mx-auto mb-4" style="max-width: 500px;">
          Explora nuestro catálogo de productos en tecnología, moda, hogar y belleza con opciones de envío seguro y Pago
          Contra Entrega a toda Colombia.
        </p>
        <div>
          <a routerLink="/shop" class="btn btn-primary font-weight-bold px-4 py-2 rounded-pill shadow-sm">
            <i class="fas fa-shopping-bag me-2"></i> Explorar Catálogo de Productos
          </a>
        </div>
      </div>

    </div>

    <!-- Tab 2: Addresses -->
    <div *ngIf="activeTab === 'addresses'" class="tab-content-addresses">
      <div class="card p-4 border shadow-sm rounded-4 bg-white">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="font-weight-bold m-0"><i class="fas fa-map-marker-alt text-primary me-2"></i> Dirección Principal
            de Entrega</h4>
          <button (click)="setTab('account')" class="btn btn-outline-primary btn-sm font-weight-bold rounded-pill">
            <i class="fas fa-edit me-1"></i> Modificar Dirección
          </button>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="border rounded-3 p-4 bg-light position-relative">
              <span class="badge bg-primary text-white position-absolute"
                style="top: 15px; right: 15px;">Predeterminada</span>
              <h5 class="font-weight-bold mb-2 text-dark"><i class="fas fa-home me-2 text-primary"></i> {{ userName }}
              </h5>
              <p class="mb-1 text-dark font-weight-semibold">{{ userAddress }}</p>
              <p class="mb-1 text-muted small"><i class="fas fa-city me-1"></i> {{ userLocation }}</p>
              <p class="mb-0 text-muted small"><i class="fas fa-phone me-1"></i> Celular: {{ userPhone }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Tab 4: Account Form -->
    <div *ngIf="activeTab === 'account'" class="tab-content-account">
      <div class="card p-4 border shadow-sm rounded-4 bg-white">
        <h4 class="font-weight-bold mb-3"><i class="fas fa-user-edit text-primary me-2"></i> Actualizar Datos Personales
          y Envíos</h4>
        <p class="text-muted small mb-4">Mantén tus datos actualizados para agilizar la cotización de envíos y la
          entrega de tus pedidos.</p>

        <form [formGroup]="accountForm" (ngSubmit)="onSave()">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label font-weight-bold">Nombre</label>
              <input formControlName="name" class="form-control rounded-3" type="text" placeholder="Tu nombre" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label font-weight-bold">Apellido</label>
              <input formControlName="lastName" class="form-control rounded-3" type="text" placeholder="Tu apellido" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label font-weight-bold">Correo Electrónico</label>
              <input formControlName="email" class="form-control rounded-3" type="email"
                placeholder="ejemplo@correo.com" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label font-weight-bold">Teléfono Celular</label>
              <input formControlName="phone" class="form-control rounded-3" type="tel" placeholder="300 000 0000" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-7 mb-3">
              <label class="form-label font-weight-bold">Dirección de Envío Principal</label>
              <input formControlName="address" class="form-control rounded-3" type="text"
                placeholder="Carrera 10 # 20-30" />
            </div>
            <div class="col-md-5 mb-3">
              <label class="form-label font-weight-bold">Complemento / Barrio / Apto</label>
              <input formControlName="complement" class="form-control rounded-3" type="text"
                placeholder="Apto 101, Barrio Centro" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label font-weight-bold">Ciudad / Municipio</label>
              <input formControlName="city" class="form-control rounded-3" type="text"
                placeholder="Ej: Bogotá D.C., Medellín, Cali" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label font-weight-bold">Departamento</label>
              <input formControlName="departament" class="form-control rounded-3" type="text"
                placeholder="Ej: Cundinamarca, Antioquia" />
            </div>
          </div>

          <div class="mt-3">
            <button type="submit" class="btn btn-primary font-weight-bold px-4 py-2 rounded-pill shadow-sm">
              <i class="fas fa-save me-2"></i> Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>